<template>
  <div class="introduce-page">
    <div class="content-wrap" ref="contentBScrollWrap">
      <div class="container">
        <!-- <div class="text_box">
          无论您是否已成为兴业银行客户，只要您是16周岁以上（含16周岁）、在深圳市参保、持居民身份证的境内居民，即可通过“兴业社保到家” 线上申请兴业社保卡，并邮寄到家。<br>申请社保卡主要有以下几个步骤：
        </div>
        <div class="text_box">
          <img src="../../assets/01@2x.png">
          您需要提供符合要求的“照片回执码”。可以通过具有拍摄社保照片资质的照相馆（在社保到家专区中第三方公司提供有线上照相相关功能，仅供参考），获得“照片回执码”。
        </div>
        <div class="text_box">
          <img src="../../assets/02@2x.png">
          登录“兴业社保到家”。在登录帐号栏位输入身份<br>证号码，之后按系统提示进行操作：<br>
          (1)如用户已注册，继续输入登录密码即可。<br>
          (2)如用户未注册，系统将引导进入注册流程。
        </div>
        <div class="text_box">
          <img src="../../assets/03@2x.png">
          上传身份证，填写兴业社保卡申请的相关信息，<br>提交申请。
        </div>
        <div class="text_box">
          <img src="../../assets/04@2x.png">
          提交申请成功后，我行将制作社保卡并邮寄给您。
        </div>
        <div class="text_box">
          <img src="../../assets/05@2x.png">
          您首次使用该卡前，请携带身份证、兴业社保卡到深圳地区的兴业银行网点进行激活即可。
        </div> -->
        <div class="btn" @click="$router.push('home')"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
    if (this.$route.query.channelId) {
      // console.log('渠道', this.$route.query.channelId)
      this.$store.commit('setChannel', this.$route.query.channelId)
    }
  }
}
</script>

<style lang="scss" scoped>
.introduce-page {
  // height: 100vh;
  .container {
    width: 100%;
    height: 5594px;
    // min-height: 350vh;
    box-sizing: border-box;
    padding-top: 659px;
    background: url('../../assets/introduce-1.png') no-repeat;
    background-size: 100%;
    .text_box {
      width: 670px;
      height: auto;
      display: block;
      margin: auto;
      margin-bottom: 20px;
      background: #3a6ed6;
      border: 4px solid #ffffff;
      border-radius: 20px;
      box-sizing: border-box;
      padding: 40px 10px 50px 24px;
      color: #fff;
      font-size: 28px;
      line-height: 1.5;
      img {
        width: 62px;
        height: 48px;
        display: block;
        margin-bottom: 15px;
      }
    }
    .btn {
      background: url('../../assets/introduce-2.png') no-repeat;
      background-size: 100%;
      width: 662px;
      height: 120px;
      position: fixed;
      left: 44px;
      bottom: 40px;
    }
  }
}
</style>
l
